const locations = [
  {
    name: "San Rafael, CA",
    address: "Irwin St, San Rafael, CA",
    detail: "Primary facility — central Marin County access",
    phone: "(415) 453-9180",
    tel: "4154539180",
  },
  {
    name: "Point Richmond, CA",
    address: "Canal Blvd, Point Richmond, CA (near Standard Oil Refinery)",
    detail: "East Bay facility — 15 min / 9 miles from San Rafael",
    phone: "(415) 846-4281",
    tel: "4158464281",
  },
];

const serviceAreas = [
  "San Rafael",
  "Point Richmond",
  "Mill Valley",
  "San Anselmo",
  "Fairfax",
  "Corte Madera",
  "Novato",
  "Petaluma",
  "Berkeley",
  "Oakland",
  "Marin County",
  "East Bay Region",
];

export default function ServiceAreas() {
  return (
    <section id="areas" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left Content */}
          <div>
            <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
              Where We Are
            </p>
            <h2 className="font-serif text-charcoal text-4xl lg:text-5xl font-bold mb-6">
              Serving the Bay Area
            </h2>
            <p className="font-sans text-[#666] text-base leading-relaxed mb-10">
              With two convenient indoor storage facilities in the Bay Area, Don Collins Auto Storage offers premium vehicle protection to collectors and owners across Marin County and the greater East Bay region.
            </p>

            {/* Locations */}
            <div className="space-y-6 mb-10">
              {locations.map((loc) => (
                <div
                  key={loc.name}
                  className="border border-[#E8E8E8] rounded-lg p-6 hover:border-gold/40 transition-colors duration-200"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-gold/10 rounded-lg flex-shrink-0 mt-0.5">
                      <i className="ri-building-3-line text-gold text-lg"></i>
                    </div>
                    <div>
                      <h3 className="font-serif text-charcoal text-lg font-semibold mb-1">
                        {loc.name}
                      </h3>
                      <p className="font-sans text-[#666] text-sm mb-1">{loc.address}</p>
                      <p className="font-sans text-[#999] text-xs italic mb-2">{loc.detail}</p>
                      <a
                        href={`tel:${loc.phone.replace(/\D/g, "")}`}
                        className="font-sans text-gold text-sm flex items-center gap-1 hover:text-gold-dark transition-colors cursor-pointer"
                      >
                        <i className="ri-phone-line text-sm"></i>
                        {loc.phone}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right – Map + Areas */}
          <div>
            {/* Google Map Embed */}
            <div className="w-full h-64 rounded-lg overflow-hidden border border-[#E8E8E8] mb-8">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3148.9!2d-122.5311!3d37.9735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085976bc01a55bb%3A0x55a0e4e18a45ef5a!2s130%20Grant%20Ave%2C%20San%20Rafael%2C%20CA%2094901!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Don Collins Auto Storage location map"
              ></iframe>
            </div>

            {/* Service Area Tags */}
            <div>
              <p className="font-sans text-[#666] text-xs tracking-[0.2em] uppercase font-semibold mb-4">
                Areas We Serve
              </p>
              <div className="flex flex-wrap gap-2">
                {serviceAreas.map((area) => (
                  <span
                    key={area}
                    className="font-sans text-xs text-[#555] bg-[#F5F5F5] border border-[#E8E8E8] px-3 py-1.5 rounded-full"
                  >
                    {area}
                  </span>
                ))}
              </div>
              <p className="font-sans text-[#999] text-xs mt-4 italic">
                Coverage expanding — contact us to confirm availability in your area.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
